export const categories = [
  { code: '1', categoryEn: 'politics', categoryPr: 'سیاسی' },
  { code: '2', categoryEn: 'economics', categoryPr: 'اقتصادی' },
  { code: '3', categoryEn: 'sports', categoryPr: 'ورزشی' },
  { code: '4', categoryEn: 'social', categoryPr: 'اجتماعی' },
  { code: '5', categoryEn: 'culture_art', categoryPr: 'فرهنگی هنری' },
  { code: '6', categoryEn: 'science', categoryPr: 'علمی' },
  { code: '7', categoryEn: 'technology', categoryPr: 'فناوری' },
  { code: '8', categoryEn: 'health', categoryPr: 'سلامت و پزشکی' },
  { code: '9', categoryEn: 'world', categoryPr: 'جهان' },
  { code: '10', categoryEn: 'environment_energy', categoryPr: 'محیط زیست و انرژی' },
  { code: '12', categoryEn: 'entertainment_lifestyle', categoryPr: 'سرگرمی و سبک زندگی' },
  { code: '13', categoryEn: 'province', categoryPr: 'استان' },
  { code: '14', categoryEn: 'miscellaneous', categoryPr: 'سایر - گوناگون' },
];

export const subs = [
  // ---- سیاسی ----
  { code: '11', subCategoryEn: 'internal', subCategoryPr: 'داخلی', surCode: '1' },
  { code: '12', subCategoryEn: 'parties_characters', subCategoryPr: 'احزاب و شخصیت‌ها', surCode: '1' },
  { code: '13', subCategoryEn: 'military_defense_security', subCategoryPr: 'نظامی-دفاعی-امنیتی', surCode: '1' },
  { code: '14', subCategoryEn: 'elections', subCategoryPr: 'انتخابات', surCode: '1' },
  { code: '15', subCategoryEn: 'foreign_policy', subCategoryPr: 'سیاست خارجی', surCode: '1' },
  { code: "16", subCategoryEn: "government_parliaments", subCategoryPr: "دولت و مجلس‌ها", surCode: "1" },

  // ---- اقتصادی ----
  { code: '21', subCategoryEn: 'macroeconomics', subCategoryPr: 'اقتصاد کلان', surCode: '2' },
  { code: '22', subCategoryEn: 'capital_market', subCategoryPr: 'بازار سرمایه', surCode: '2' },
  { code: '23', subCategoryEn: 'banking_insurance', subCategoryPr: 'بانک و بیمه', surCode: '2' },
  { code: '24', subCategoryEn: 'trade_industry', subCategoryPr: 'تجارت و صنعت', surCode: '2' },
  { code: '25', subCategoryEn: 'housing_urban', subCategoryPr: 'مسکن و شهرسازی', surCode: '2' },
  { code: '26', subCategoryEn: 'labor_employment', subCategoryPr: 'کار و اشتغال', surCode: '2' },
  { code: '27', subCategoryEn: 'energy_oil_gas', subCategoryPr: 'انرژی، نفت و گاز', surCode: '2' },
  { code: "28", subCategoryEn: "agriculture", subCategoryPr: "کشاورزی", surCode: "2" },

  // ---- ورزشی ----
  { code: '31', subCategoryEn: 'football', subCategoryPr: 'فوتبال', surCode: '3' },
  { code: '32', subCategoryEn: 'volleyball', subCategoryPr: 'والیبال', surCode: '3' },
  { code: '33', subCategoryEn: 'basketball', subCategoryPr: 'بسکتبال', surCode: '3' },
  { code: '34', subCategoryEn: 'combat_sports', subCategoryPr: 'ورزش‌های رزمی', surCode: '3' },
  { code: '35', subCategoryEn: 'international_competitions', subCategoryPr: 'المپیک و مسابقات جهانی', surCode: '3' },
  { code: "36", subCategoryEn: "racket_sports", subCategoryPr: "ورزش‌های راکتی", surCode: "3" },

  // ---- اجتماعی ----
  { code: '41', subCategoryEn: 'education', subCategoryPr: 'آموزش و پرورش', surCode: '4' },
  { code: '42', subCategoryEn: 'family', subCategoryPr: 'خانواده', surCode: '4' },
  { code: '43', subCategoryEn: 'social_issues', subCategoryPr: 'آسیب‌های اجتماعی', surCode: '4' },
  { code: '44', subCategoryEn: 'welfare', subCategoryPr: 'رفاه و تأمین اجتماعی', surCode: '4' },
  { code: "45", subCategoryEn: "judicial_legal", subCategoryPr: "قضایی حقوقی", surCode: "4" },
  { code: "46", subCategoryEn: "military_service", subCategoryPr: "سربازی و نظام وظیفه", surCode: "4" },
  { code: "47", subCategoryEn: "accidents", subCategoryPr: "حوادث", surCode: "4" },

  // ---- فرهنگی هنری ----
  { code: '51', subCategoryEn: 'cinema_tv', subCategoryPr: 'سینما و تلویزیون', surCode: '5' },
  { code: '52', subCategoryEn: 'music', subCategoryPr: 'موسیقی', surCode: '5' },
  { code: '53', subCategoryEn: 'theatre', subCategoryPr: 'تئاتر', surCode: '5' },
  { code: '54', subCategoryEn: 'literature_books', subCategoryPr: 'ادبیات و کتاب', surCode: '5' },
  { code: '55', subCategoryEn: 'tourism_heritage', subCategoryPr: 'گردشگری و میراث فرهنگی', surCode: '5' },
  { code: "56", subCategoryEn: "humor_cartoon", subCategoryPr: "طنز و کاریکاتور", surCode: "5" },
  { code: "57", subCategoryEn: "visual_arts", subCategoryPr: "تجسمی", surCode: "5" },
  { code: "58", subCategoryEn: "media", subCategoryPr: "رسانه", surCode: "5" },
  { code: "59", subCategoryEn: "religion_philosophy", subCategoryPr: "دین و اندیشه", surCode: "5" },
  { code: "60", subCategoryEn: "history", subCategoryPr: "تاریخ", surCode: "5" },

  // ---- علمی ----
  { code: '61', subCategoryEn: 'research', subCategoryPr: 'پژوهش', surCode: '6' },
  { code: '62', subCategoryEn: 'innovation', subCategoryPr: 'نوآوری', surCode: '6' },
  { code: '63', subCategoryEn: 'space', subCategoryPr: 'فضا و نجوم', surCode: '6' },

  // ---- فناوری ----
  { code: '71', subCategoryEn: 'it_internet', subCategoryPr: 'IT و اینترنت', surCode: '7' },
  { code: '72', subCategoryEn: 'ai', subCategoryPr: 'هوش مصنوعی', surCode: '7' },
  { code: '73', subCategoryEn: 'gadgets', subCategoryPr: 'ابزارها و گجت‌ها', surCode: '7' },

  // ---- سلامت ----
  { code: '81', subCategoryEn: 'medicine', subCategoryPr: 'دارو و درمان', surCode: '8' },
  { code: '82', subCategoryEn: 'diseases', subCategoryPr: 'بیماری‌ها', surCode: '8' },
  { code: '83', subCategoryEn: 'nutrition', subCategoryPr: 'تغذیه و ورزش', surCode: '8' },
  { code: '84', subCategoryEn: 'public_health', subCategoryPr: 'بهداشت عمومی', surCode: '8' },

  // ---- جهان ----
  { code: '91', subCategoryEn: 'middle_east', subCategoryPr: 'خاورمیانه', surCode: '9' },
  { code: '92', subCategoryEn: 'europe', subCategoryPr: 'اروپا', surCode: '9' },
  { code: '93', subCategoryEn: 'america', subCategoryPr: 'آمریکا', surCode: '9' },
  { code: '94', subCategoryEn: 'asia', subCategoryPr: 'آسیا', surCode: '9' },
  { code: '95', subCategoryEn: 'africa', subCategoryPr: 'آفریقا', surCode: '9' },
  { code: '96', subCategoryEn: 'oceania', subCategoryPr: 'اقیانوسیه', surCode: '9' },

  // ---- محیط زیست ----
  { code: '101', subCategoryEn: 'climate_change', subCategoryPr: 'تغییرات اقلیمی', surCode: '10' },
  { code: '102', subCategoryEn: 'pollution', subCategoryPr: 'آلودگی هوا و آب', surCode: '10' },
  { code: '103', subCategoryEn: 'natural_resources', subCategoryPr: 'منابع طبیعی', surCode: '10' },
  { code: '104', subCategoryEn: 'renewable_energy', subCategoryPr: 'انرژی‌های نو', surCode: '10' },

  // ---- سرگرمی و سبک زندگی ----
  { code: '121', subCategoryEn: 'fashion', subCategoryPr: 'مد و پوشاک', surCode: '12' },
  { code: '122', subCategoryEn: 'cooking', subCategoryPr: 'آشپزی', surCode: '12' },
  { code: '123', subCategoryEn: 'decoration', subCategoryPr: 'دکوراسیون', surCode: '12' },
  { code: '124', subCategoryEn: 'psychology_success', subCategoryPr: 'موفقیت و روانشناسی', surCode: '12' },
  { code: '125', subCategoryEn: 'travel', subCategoryPr: 'گردشگری و سفر', surCode: '12' },  

  // ---- استان ----
  { code: '131', subCategoryEn: 'local_news', subCategoryPr: 'اخبار محلی', surCode: '13' },
  { code: '132', subCategoryEn: 'municipality', subCategoryPr: 'شهرداری و مدیریت شهری', surCode: '13' },

];
